import { addDays, startOfDay, differenceInDays } from 'date-fns';

export const DAY_WIDTH = 60; 
export const HEADER_HEIGHT = 60;
export const ROW_HEIGHT = 50;

export const getDaysInView = (startDate: Date, viewMode: string, endDate?: Date) => {
  const days = [];
  const start = startOfDay(startDate);
  
  if (endDate) {
    // Calculate total days between start and end date
    const totalDays = differenceInDays(endDate, start) + 1; // +1 to include end date
    
    for (let i = 0; i < totalDays; i++) {
      days.push(addDays(start, i));
    }
  } else {
    // Fallback: 31 days agar end date nahi hai
    for (let i = 0; i < 31; i++) {
      days.push(addDays(start, i));
    }
  }
  
  return days;
};

export const getPixelFromDate = (date: Date, startDate: Date, viewMode: string) => {
  const diffTime = date.getTime() - startDate.getTime();
  const oneDay = 1000 * 60 * 60 * 24;
  return (diffTime / oneDay) * DAY_WIDTH;
};

export const getDateFromPixel = (pixel: number, startDate: Date, viewMode: string) => {
  const daysToAdd = pixel / DAY_WIDTH;
  const oneDay = 1000 * 60 * 60 * 24;
  return new Date(startDate.getTime() + daysToAdd * oneDay);
};

export const flattenResources = (resources: any[], expandedIds: Set<string>, depth = 0) => {
  let flat: any[] = [];
  resources.forEach(r => {
    flat.push({ ...r, depth });

    if (expandedIds.has(r.id)) {
      if (r.children && r.children.length > 0) {
        flat = flat.concat(flattenResources(r.children, expandedIds, depth + 1));
      }

      if (r.type === 'project') {
        flat.push({
          id: `btn-add-${r.id}`, 
          AccountEmployeeId: r.id,
          parentId: r.id,
          ProjectId: r.id,
          name:'Add Employee',
          type: 'add_button',
          depth: depth + 1,
          hasChildren: false,
          parentName: r.name,
          clientName: r.subtitle,
          HoursPerDay: r?.HoursPerDay,
          originalProjectData: r.originalData,
          enableBtn: r?.IsProjectManager ? r?.IsProjectManager : r?.IsMyProject
        });
      }
       if (r.type === 'team') {
        flat.push({
          id: `btn-add-${r.id}`, 
          AccountEmployeeId: r.id,
          parentId: r.id,
          EmployeeId: r.id,
          name:'Add Project',
          type: 'add_button',
          depth: depth + 1,
          hasChildren: false,
          parentName: r.name,
          clientName: r.subtitle,
          HoursPerDay: r.HoursPerDay,
          originalProjectData: r.originalData,
          enableBtn: true
        });
      }
    }
  });

  return flat;
};

export const countAllDays = (startDate: Date, endDate: Date): number => {
  if (!startDate || !endDate) return 0;
  
  const start = new Date(startDate);
  const end = new Date(endDate);
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);
  const diffTime = Math.abs(end.getTime() - start.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
  
  return diffDays;
};

export const countWorkingDays = (startDate: Date, endDate: Date): number => {
  if (!startDate || !endDate) return 0;

  const start = new Date(startDate);
  const end = new Date(endDate);
  
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  let count = 0;
  const current = new Date(start);

  while (current <= end) {
    const dayOfWeek = current.getDay();
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      count++;
    }
    current.setDate(current.getDate() + 1);
  }

  return count;
};

export const isWeekendDay = (date: Date): boolean => {
  const day = date.getDay();
  return day === 0 || day === 6;
};